export default __webpack_public_path__ + "static/media/vna-inline.e62babab.svg";